import * as React from 'react';
import { cn } from '@/lib/utils';

/**
 * Skeleton — a single content placeholder block shown while data loads.
 *
 * Renders a muted block with a soft sheen sweep (see `.skeleton` in
 * global.css; the sweep collapses to a static block under
 * prefers-reduced-motion). Compose several to mirror the shape of the
 * content being loaded — a wide bar for a name, a small circle for an
 * avatar, etc. Decorative by default (aria-hidden); wrap a group in a
 * `role="status"` container with an aria-label so assistive tech still
 * hears "loading". `TableSkeleton` does exactly this for table pages.
 */
export function Skeleton({
  className,
  ...props
}: React.HTMLAttributes<HTMLDivElement>) {
  return (
    <div aria-hidden="true" className={cn('skeleton rounded-md', className)} {...props} />
  );
}
